
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsDiscCouponTypeDaysGrid extends Serenity.EntityGrid<PsDiscCouponTypeDaysRow, any> {
        protected getColumnsKey() { return PsDiscCouponTypeDaysColumns.columnsKey; }
        protected getDialogType() { return PsDiscCouponTypeDaysDialog; }
        protected getIdProperty() { return PsDiscCouponTypeDaysRow.idProperty; }
        protected getInsertPermission() { return PsDiscCouponTypeDaysRow.insertPermission; }
        protected getLocalTextPrefix() { return PsDiscCouponTypeDaysRow.localTextPrefix; }
        protected getService() { return PsDiscCouponTypeDaysService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}